import api from "services/trainees";

const state = {
  trainees: [],
  selectedTrainee: {},
  filter: "all",
  pagination: [],
  totalPages: "",
  currentPage: "",
  searchQuery: {
    search: null,
    offers: null,
    time: null,
    sessions: null,
    campuses: null,
    week: null,
    begin: null,
    end: null,
    categories: []
  },
  selectedFilters: {
    search: null,
    offers: null,
    time: null,
    sessions: null,
    campuses: null,
    week: null,
    begin: null,
    end: null,
    categories: []
  },
  status: null
};

const getters = {
  trainees: state => state.trainees,
  selectedTrainee: state => state.selectedTrainee,
  searchQuery: state => state.searchQuery,
  selectedFilters: state => state.selectedFilters,
  status: state => state.status,
  totalPages(state) {
    return state.pagination.total_pages;
  },
  currentPage(state) {
    return state.pagination.current_page;
  },
  pagination(state) {
    return state.pagination;
  }
};

const mutations = {
  setTrainees: (state, payload) => {
    state.trainees = payload.users;
    state.pagination = payload.meta.pagination;
    const { total, limit, skip } = state.pagination;
    state.totalPages = Math.ceil(total / limit);
    state.currentPage = Math.ceil((skip - 1) / limit) + 1;
  },
  selectTrainee: (state, payload) => {
    state.selectedTrainee = payload;
  },
  resetSearch: state => {
    state.selectedFilters = {
      search: null,
      offers: null,
      time: null,
      sessions: null,
      campuses: null,
      week: null,
      begin: null,
      end: null,
      categories: []
    };

    state.searchQuery = {
      search: null,
      offers: null,
      time: null,
      sessions: null,
      campuses: null,
      week: null,
      begin: null,
      end: null,
      categories: []
    };
  },
  setStatus: (state, payload) => {
    state.status = payload.status;
  }
};

const actions = {
  async getTrainees({ commit }, query) {
    const payload = await api.search(query);
    if ((await payload.status) === 200) {
      commit("setTrainees", await payload.data);
    }
    commit("setStatus", await payload);
  },
  async getTrainee({ commit }, id) {
    const payload = (await api.showUser(id)).data;
    commit("selectTrainee", await payload);
  },
  async updateUser({ commit, state }, query) {
    const payload = (await api.updateUser(state.selected.id, query)).data;
    commit("updateUser", await payload);
  },
  resetSearch({ commit }) {
    commit("resetSearch");
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
